<template>
    <div class="root" v-loading="loading">

        <topmenu></topmenu>


        <div class="container theme-showcase">

            <div style="margin-top: 20px; display: flex; align-items: center;">
                <div style="flex:1;">
                    <el-button type="primary" icon="el-icon-plus" size="medium" @click="add">添加</el-button>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-refresh" size="medium" @click="refresh">刷新</el-button>
                </div>
            </div>

            <div style="margin: 16px 0;">
                <el-table :data="list" border style="width: 100%">
                    <el-table-column prop="index" label="序号" width="50">
                    </el-table-column>
                    <el-table-column prop="name" label="类别" width="950">
                    </el-table-column>
                    <el-table-column prop="ordering" label="排序" width="74">
                    </el-table-column>
                    <el-table-column label="操作" width="95">
                        <template slot-scope="scope">

                            <el-button size="mini" type="primary" icon="el-icon-edit" circle
                                @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button size="mini" type="danger" icon="el-icon-delete" circle
                                @click="handleDelete(scope.$index, scope.row)"></el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin:12px 0;">
                    <div v-if="total > 1">
                        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                            :current-page.sync="currentPage" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>


            <el-dialog title="类别管理" :visible.sync="dialogFormVisible" width="650px">
                <el-form :model="form" label-width="80px">
                    <el-form-item label="名称:" required :error="nameErr">
                        <el-input v-model="Name" @change="nameChange"></el-input>
                    </el-form-item>
                    <el-form-item label="序号:">
                        <el-input v-model="Ordering" type="number" @change="orderingChange"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="submit">确定</el-button>
                </div>
            </el-dialog>


            <div style="height: 35px;"></div>
        </div>


    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../components/topmenu'

export default {
    name: 'PromoCodelist',
    data: function () {
        return {
            list: [],
            loading: false,
            id: '',
            Name: '',
            Ordering: 0,
            dialogFormVisible: false,
            nameErr:'',

        }
    },
    components: {
        topmenu
    },
    methods: {
        add() {
            this.dialogFormVisible = true;
            this.id = '';
            this.Name = '';
            this.Ordering = '';
            this.nameErr="";
        },
        refresh() {
            this.loadData(1);
        },
        loadData(page) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/CategoryList',
                {
                    skip: (page - 1) * 100,
                    limit: 10,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.total = res.total;
                this.list = res.list;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        submit() {
            if (this.Name == '') {
                this.nameErr = "请输入";
                return;
            } else {
                this.nameErr = "";
            }
            this.onSubmit();
        },
        onSubmit() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));

            var uid = userJson.uid;
            var token = userJson.token;
            var url = 'api/Suggestion/CreateCategory';
            if (this.id > 0) {
                url = 'api/Suggestion/UpdateCategory';
            }
            axios.post(url,
                {
                    uid: uid,
                    token: token,
                    id: this.id,
                    name: this.Name,
                    ordering: this.Ordering
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.$message({
                    message: '操作成功!',
                    type: 'success',
                    onClose: () => {
                    }
                });
                this.dialogFormVisible = false;
                this.loadData(1);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },
        handleEdit(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);
            this.id = id;
            this.nameErr="";
            this.Name = row.name;
            this.Ordering = row.ordering;
            this.dialogFormVisible = true;
        },

        
        handleDelete(index, row) {
            console.log(index, row);
            var id = row.id;
            console.log(id);

            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delCate(id);
            });

        },
        
        delCate(id) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Suggestion/DeleteCategory',
                {
                    id: id,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.delCateSucc)
        },
        delCateSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.loadData(1);
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

    },
    mounted() {

        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
        this.loadData(1);
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.root>>>.topmenuitem:nth-child(3) {
    color: #fff;
    background-color: #080808;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/PromoCode/PromoCodelist.vue